import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { Styles } from "./styles/faqEvent.js";
import axios from "axios";
import { Constant } from "../helper/Constants.js";

function FaqEvent() {
  const [allEvents, setAllEvents] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [activeFaqIndex, setActiveFaqIndex] = useState(null);

  const fetchAllEvents = async () => {
    try {
      const resp = await axios.get(Constant.getUrls.getAllEvents + "?limit=3&search=upcoming");
      const rows = resp.data?.data || [];
      setAllEvents(Array.isArray(rows) ? rows : []);
    } catch (error) {
      console.error(
        "Failed to fetch events:",
        error?.response?.data || error.message,
      );
    }
  };

  const fetchFaqs = async () => {
    try {
      const url = Constant.getUrls?.getAllFaqs || "/api/faqs";
      const resp = await axios.get(`${url}?page=1&limit=100`);
      const payload = resp.data?.data;
      const rows = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.docs)
          ? payload.docs
          : [];
      setFaqs(rows);
    } catch (error) {
      console.error(
        "Failed to fetch faqs:",
        error?.response?.data || error.message,
      );
      setFaqs([]);
    }
  };

  useEffect(() => {
    fetchAllEvents();
    fetchFaqs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getShortContent = (htmlContent) => {
    if (!htmlContent) return "";
    const text = htmlContent.replace(/<[^>]*>?/gm, "");
    return text.length > 80 ? text.substring(0, 80) + "..." : text;
  };

  const formatShortDate = (date) => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";
    const day = d.getDate();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return `${day} ${monthNames[d.getMonth()]}`;
  };

  const formatTime12Hour = (date) => {
    // preserve your IST adjustment if needed
    const istDate = new Date(date).getTime() - 19800000;
    const d = new Date(istDate);
    if (isNaN(d.getTime())) return "";
    let hours = d.getHours();
    const minutes = d.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const mins = minutes < 10 ? `0${minutes}` : minutes;
    return `${hours}:${mins} ${ampm}`;
  };

  const toggleFaq = (index) => {
    setActiveFaqIndex((prev) => (prev === index ? null : index));
  };

  return (
    <Styles>
      {/* Faq & Event */}
      <section className="event-faq-area">
        <Container>
          <Row>
            <Col md="6">
              <div className="event-area">
                <Row>
                  <Col md="12">
                    <div className="sec-title">
                      <h4>
                        Upcoming <span>Events</span>
                      </h4>
                    </div>
                  </Col>
                  <Col md="12">
                    {Array.isArray(allEvents) && allEvents.length > 0 ? (
                      allEvents.map((eventData, i) => (
                        <div
                          className="event-box d-flex"
                          key={eventData._id || i}
                        >
                          <div className="event-date text-center px-1">
                            <p>{formatShortDate(eventData?.event_date)}</p>
                          </div>
                          <div className="event-details">
                            <h6>
                              <Link
                                to={"/event-details" + eventData._id || "#"}
                              >
                                {eventData.name}
                              </Link>
                            </h6>
                            <ul className="list-unstyled list-inline">
                              <li className="list-inline-item">
                                <i className="las la-clock"></i>
                                {formatTime12Hour(eventData.event_date)}
                              </li>
                              <li className="list-inline-item">
                                <i className="las la-map-marker"></i>
                                {eventData.event_venue}
                              </li>
                            </ul>
                            <p>{getShortContent(eventData.event_details)}</p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div style={{ padding: 16 }}>
                        No upcoming events found.
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            </Col>

            <Col md="6">
              <div className="faq-area">
                <div className="sec-title">
                  <h4>
                    Frequently Ask <span>Question</span>
                  </h4>
                </div>

                <div className="faq-box">
                  {faqs.length === 0 ? (
                    <div style={{ padding: 12 }}>No FAQs available.</div>
                  ) : (
                    faqs.map((faqItem, idx) => {
                      const question =
                        faqItem.question || faqItem.title || faqItem.q || "";
                      const answer =
                        faqItem.answer ||
                        faqItem.answer_text ||
                        faqItem.desc ||
                        "";
                      const isOpen = activeFaqIndex === idx;

                      return (
                        <div
                          className="faq-item"
                          key={faqItem._id || idx}
                          style={{ marginBottom: 12 }}
                        >
                          <button
                            type="button"
                            className={`accordion-button ${isOpen ? "active" : ""}`}
                            onClick={() => toggleFaq(idx)}
                            aria-expanded={isOpen}
                            aria-controls={`faq-content-${idx}`}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                              background: "transparent",
                              border: "none",
                              padding: "12px 0",
                              cursor: "pointer",
                            }}
                          >
                            <div
                              className="accordion-icon"
                              aria-hidden
                              style={{ marginRight: 12 }}
                            >
                              <i
                                className={`las ${isOpen ? "la-minus" : "la-plus"}`}
                              ></i>
                            </div>
                            <p style={{ margin: 0 }}>{question}</p>
                          </button>

                          {/* Explicit show/hide using display so CSS won't block it */}
                          <div
                            id={`faq-content-${idx}`}
                            role="region"
                            aria-labelledby={`faq-button-${idx}`}
                            style={{
                              display: isOpen ? "block" : "none",
                              padding: isOpen ? "10px 0 0 32px" : "0 0 0 32px",
                              color: "#444",
                              lineHeight: 1.6,
                            }}
                          >
                            {/* Plain-text render. If you need HTML rendering, replace next line with dangerouslySetInnerHTML */}
                            <p style={{ margin: 0 }}>{answer}</p>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Styles>
  );
}

export default FaqEvent;
